/**
 * Confirm dialog rendered inside the Database Explorer.
 *
 * Driven by the confirmDialogStore — imperative code calls
 * `requestConfirm()` and awaits the user's choice.
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';
import { useConfirmDialogStore } from '../services/confirmDialogStore';

export function ExplorerConfirmDialog() {
  const { open, title, description, confirmLabel, confirm, cancel } = useConfirmDialogStore();
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && cancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={cancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={confirm}
            className="bg-destructive-fill text-destructive-foreground hover:bg-destructive-fill/90"
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
